import appendfragment from './appendfragment';
import striptags from './striptags';

export default {
    install(Vue) {
        Vue.filter('appendfragment', appendfragment);
        Vue.filter('striptags', striptags);
    },
};
